import {
    LIVE_BID_ACCEPTED,
    LIVE_BID_RETRACTED,
    LIVE_LOT_PASSED,
    LIVE_LOT_REOPENED,
    LIVE_LOT_SOLD,
    LIVE_LOT_UNSOLD,
    LIVE_NEXT_LOT_LOADED,
    LOAD_LIVE_CATALOG_STATUS_SUCCESS,
} from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

type LiveItemStatus = {
    bidderLiveBid: number;
    catalogId?: number;
    itemId?: number;
    open: boolean;
};

interface DefaultState {
    readonly byId: {
        [itemId: number]: LiveItemStatus;
    };
}

// reducer
const DEFAULT_STATE: DefaultState = {
    byId: {},
};

export type State = typeof DEFAULT_STATE;

const closeAllLots = (oldState, catalogId) => {
    const lots = {};
    Object.keys(oldState).forEach((cur) => {
        const lot = { ...oldState[cur] };
        if (lot.catalogId === catalogId) {
            lot.open = false;
        }
        lots[lot.itemId] = lot;
    });
    return lots;
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing: DefaultState['byId'];
    let catalogId: number;
    let itemId: number;

    switch (action.type) {
        case LIVE_BID_ACCEPTED:
            catalogId = action.payload.catalogId;
            itemId = action.payload.itemId;
            existing = closeAllLots(state.byId, catalogId);
            existing[itemId] = {
                bidderLiveBid: action.payload.myBid ? action.payload.amount : 0,
                catalogId,
                itemId,
                open: true,
            };
            return {
                ...state,
                byId: existing,
            };
        case LIVE_BID_RETRACTED:
        case LIVE_LOT_REOPENED:
        case LIVE_NEXT_LOT_LOADED:
            catalogId = action.payload.catalogId;
            itemId = action.payload.itemId;
            existing = closeAllLots(state.byId, catalogId);
            existing[itemId] = {
                bidderLiveBid: 0,
                catalogId,
                itemId,
                open: true,
            };
            return {
                ...state,
                byId: existing,
            };
        case LIVE_LOT_PASSED:
        case LIVE_LOT_SOLD:
        case LIVE_LOT_UNSOLD:
            catalogId = action.payload.catalogId;
            itemId = action.payload.itemId;
            existing = closeAllLots(state.byId, catalogId);
            existing[itemId] = {
                bidderLiveBid: 0,
                catalogId,
                itemId,
                open: false,
            };
            return {
                ...state,
                byId: existing,
            };
        case LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            const currentItem = action.payload.currentItem || {};
            catalogId = action.payload.catalogId;
            itemId = currentItem.itemId;
            const lotStatus = currentItem.lotStatus;

            if (!itemId) {
                return state;
            }

            existing = closeAllLots(state.byId, catalogId);
            existing[itemId] = {
                bidderLiveBid: 0,
                catalogId,
                itemId,
                open: lotStatus === 'open',
            };
            return {
                ...state,
                byId: existing,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.liveItemStatus;
const idSelector = (state: GlobalState, id: number) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

export const getLiveItemStatus: (state: any, selector: any) => LiveItemStatus = createSelector(
    [byIdSelector, idSelector],
    (byId, id) =>
        byId[id] || {
            bidderLiveBid: 0,
            open: false,
        }
);
